import { render, staticRenderFns } from "./_areaName.vue?vue&type=template&id=572636c8"
import script from "./_areaName.vue?vue&type=script&lang=js"
export * from "./_areaName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports